export const API_URL = "https://askabout.io/graphql";
